export default __webpack_public_path__ + "static/media/zak_faceShot1.b7ac40cf.jpg";